var _path, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3.5H11V13.5H3V3.5ZM21 3.5H13V9.5H21V3.5ZM9 11.5V5.5H5V11.5H9ZM19 7.5V5.5H15V7.5H19ZM19 13.5V19.5H15V13.5H19ZM9 19.5V17.5H5V19.5H9ZM21 11.5H13V21.5H21V11.5ZM3 15.5H11V21.5H3V15.5Z",
    fill: "#2771bb"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 18,
    height: 19
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3.5H11V13.5H3V3.5ZM21 3.5H13V9.5H21V3.5ZM9 11.5V5.5H5V11.5H9ZM19 7.5V5.5H15V7.5H19ZM19 13.5V19.5H15V13.5H19ZM9 19.5V17.5H5V19.5H9ZM21 11.5H13V21.5H21V11.5ZM3 15.5H11V21.5H3V15.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.ad3b94c326d48db26b2e4983f26979d0.svg";
export { ForwardRef as ReactComponent };